import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=33aaf285&scoped=true&"
import script from "./ClientDetails.vue?vue&type=script&lang=ts&"
export * from "./ClientDetails.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=33aaf285&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aaf285",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
